import { render, staticRenderFns } from "./AccountMessagePresets.vue?vue&type=template&id=1a0f2db0&"
import script from "./AccountMessagePresets.vue?vue&type=script&lang=js&"
export * from "./AccountMessagePresets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports